import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CrmDisplayFieldComponent } from './shared/crm-display-field/crm-display-field.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { SalesforceInteractionsComponent } from './shared/salesforce-interactions/salesforce-interactions.component';
import { ZendeskInteractionsComponent } from './shared/zendesk-interactions/zendesk-interactions.component';

/**
 * This module contains all the features needed to manage the customer's properties from the TPP.
 */
@NgModule({
  declarations: [CrmDisplayFieldComponent, SalesforceInteractionsComponent, ZendeskInteractionsComponent],
  imports: [CommonModule, SharedModule],
})
export class UserModule {}
